<template>
   <div id="nav">
      <router-link to="/Home" v-on:click.native="tabClick(0)">
        <img :src="tabList[0]?tabImg[0].showNow:tabImg[0].showNo" alt />
        <span :style="tabList[0]?'color:#cd160d':'#826967'">首页</span>
      </router-link>
      <router-link to="/map" v-on:click.native="tabClick(1)">
        <img :src="tabList[1]?tabImg[1].showNow:tabImg[1].showNo" alt />
        <span :style="tabList[1]?'color:#cd160d':'#826967'">地图领劵</span>
      </router-link>
      <router-link to="/water" v-on:click.native="tabClick(2)">
        <img :src="tabList[2]?tabImg[2].showNow:tabImg[2].showNo" alt />
        <span :style="tabList[2]?'color:#cd160d':'#826967'">免费饮水点</span>
      </router-link>
      <router-link to="/My" v-on:click.native="tabClick(3)">
        <img :src="tabList[3]?tabImg[3].showNow:tabImg[3].showNo" alt />
        <span :style="tabList[3]?'color:#cd160d':'#826967'">我的</span>
      </router-link>
    </div>
</template>

<script>
export default {
  name: "",
  props:['tabindex'],
  data() {
    return {
      a: false,
      tabList: [0,0,0,0],
      tabImg: [
        {
          showNow: require("../assets/index01.png"),
          showNo: require("../assets/index02.png")
        },
        {
          showNow: require("../assets/map01.png"),
          showNo: require("../assets/map02.png")
        },
         {
          showNow: require("../assets/water01.png"),
          showNo: require("../assets/water02.png")
        },
        {
          showNow: require("../assets/us01.png"),
          showNo: require("../assets/us02.png")
        }
      ]
    };
  },
  components: {},
  created() {},
  mounted() {
    this.$set(this.tabList, this.tabindex, 1);
    console.log(this.tabindex)
  },
  methods: {
    tabClick(index) {
      console.log(index)
      this.$set(this.tabList, 0, 0);
      this.$set(this.tabList, 1, 0);
      this.$set(this.tabList, 2, 0);
      this.$set(this.tabList, 3, 0);
      this.$set(this.tabList, index, 1);
    }
  }
};
</script>
<style lang="scss">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
a {
  text-decoration: none;
  color: black;
}
/*正常的未被访问过的链接*/
a:link {
  text-decoration: none;
}
/*已经访问过的链接*/
a:visited {
  text-decoration: none;
}
/*鼠标划过(停留)的链接*/
a:hover {
  text-decoration: none;
}
/* 正在点击的链接*/
a:active {
  text-decoration: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  -webkit-user-select: none;
  -moz-user-focus: none;
  -moz-user-select: none;
}
#nav {
  width: 100%;
  height: 0.98rem;
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 0.2rem;
  border-top: 1px solid #e5e5e5;
  background: rgba(255, 255, 255, 1)
}
#nav a {
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  align-items: center;
}
#nav a img {
  width: 0.5rem;
  height: 0.5rem;
}
#nav a span {
  display: inline-block;
  line-height: 0.3rem;
  font-size: 0.2rem;
  margin-top: 0.05rem;
}
</style>

